import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, AlertController, PopoverController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import { PopupPage } from '../../popup/popup';
import * as moment from 'moment';
import { VehshiftsmodifyPage } from './vehshiftsmodify/vehshiftsmodify';

/**
 * Generated class for the WorkshiftPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editvehshifts',
  templateUrl: 'editvehshifts.html',
})
export class EditvehshiftsPage {
  loadingData: boolean = false
  priv: boolean = false
  worktime = []
  days = []
  ajde = []
  Group = []
  GroupElements = 0
  alldrivers = []
  VehicleID = ''

  // zaRefresh = []

  constructor(public navCtrl: NavController, public navParams: NavParams, public popoverCtrl: PopoverController, public dic: DIC, public gn: GN, public modalCtrl: ModalController, public alertCtrl: AlertController) {
    this.days.push({ name: this.dic.l["Monday"], id: 1 }, { name: this.dic.l["Tuesday"], id: 2 }, { name: this.dic.l["Wednesday"], id: 3 }, { name: this.dic.l["Thursday"], id: 4 }, { name: this.dic.l["Friday"], id: 5 }, { name: this.dic.l["Saturday"], id: 6 }, { name: this.dic.l["Sunday"], id: 7 }, { name: this.dic.l["holiday"], id: 8 })
    this.VehicleID = navParams.get('vehicle')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditvehshiftsPage');
    this.loadData()

    var _that = this;
    if (this.gn.clientsettings.indoor > 0) {
      this.gn._Post('/api/gn/getalldrivers', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
        _that.alldrivers = _data
      })
    }
  }

  loadData() {
    this.Group = []
    this.loadingData = true
    this.priv = this.gn.getPriv('worktime')
    console.log(this.priv, 'this priv da vidam')
    var _that = this
    this.gn._Post('/api/gn/getVehShifts', { vid: this.gn.crypt(this.VehicleID) }, function (_data) {
      _that.worktime = _data
      for (let k = 0; k < _that.days.length; k++) {
        _that.Group.push({ id: _that.days[k].id, name: _that.days[k].name, ajde: [] })
        for (let m = 0; m < _data.length; m++) {
          if (_that.days[k].id == _data[m].dow) {
            _data[m].timefrom = _data[m].timefrom.slice(0, _data[m].timefrom.length - 3);
            _data[m].timeto = _data[m].timeto.slice(0, _data[m].timeto.length - 3);
            _that.Group[_that.Group.length - 1].ajde.push(_data[m])
            _that.GroupElements++;
          }
        }
      }
      _that.loadingData = false
    })
  }

  editShift(_u) {
    var _that = this
    let modal = this.modalCtrl.create(VehshiftsmodifyPage, {
      gr: _u, cb: function () {
        _that.loadData()
      }
    });
    modal.present();
  }

  addShift() {
    var _that = this
    let modal = this.modalCtrl.create(VehshiftsmodifyPage, {
      gr: { id: -1, vehid: _that.VehicleID }, cb: function () {
        _that.loadData()
      }
    });
    modal.present();
  }

  DeleteShift(_id) {
    var _that = this
    let confirm = this.alertCtrl.create({
      // message: this.dic.l["delcommand"],
      message: this.dic.l["delworktime"],
      buttons: [
        {
          text: this.dic.l["NO"],
          handler: () => {
          }
        },
        {
          text: this.dic.l["YES"],
          handler: () => {
            _that.gn._Post('/api/gn/deleteVehShifts', { id: _that.gn.crypt(_id) }, function (_data) {
              _that.loadData()
            })
          }
        }
      ]
    });
    confirm.present();

  }

  dowloadShifts() {
    var _that = this;
    let alert = _that.alertCtrl.create({
      title: _that.dic.l["downloadShifts"],
      subTitle: _that.dic.l["areyouwantodownloadshifts"],
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {
            _that.gn.loadWaiting();
            this.gn._Post('/api/gn/deleteVehShifts', { vehid: this.gn.crypt(this.VehicleID) }, function (_data2) {
              _that.gn._Post('/api/gn/getWorktime', { cid: _that.gn.crypt(_that.gn.user.ClientId) }, function (_data) {
                var _dat = {}
                var _cnt = 0
                var _len = _data.length
                for (var idx = 0; idx < _data.length; idx++) {
                  _dat = {
                    cid: _that.gn.crypt(_that.gn.user.ClientId),
                    vehid: _that.gn.crypt(_that.VehicleID),
                    dow: _that.gn.crypt(_data[idx].daytype),
                    timefrom: _that.gn.crypt(_data[idx].timefrom),
                    timeto: _that.gn.crypt(_data[idx].timeto),
                    id: _that.gn.crypt(-1),
                  }

                  _that.gn._Post('/api/gn/vehShift', _dat, function (_data1) {
                    _cnt++
                    if (_cnt == _len) {
                      _that.loadData()
                      _that.gn.loaderWaiting.dismiss();
                    }
                  })
                }
              })
            })
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel'
        }
      ]
    });
    alert.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/settings/editvehshifts/editvehshifts.ts